var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "scheduler-modal__buttons" },
    [
      _c(
        "back-cancel-button",
        _vm._g({ attrs: { "active-step": _vm.activeStep } }, _vm.$listeners)
      ),
      _vm._v(" "),
      _c(
        "next-save-button",
        _vm._g(
          {
            attrs: {
              "active-step": _vm.activeStep,
              "disabled-next-button": _vm.disabledNextButton,
              "disabled-save-buttons": _vm.disabledSaveButtons,
              "disabled-edit-button": _vm.disabledEditButton,
              editedFeed: _vm.editedFeed,
            },
          },
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }